import { Button } from 'primereact/button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import 'date-fns';
// import { useFormik } from "formik";
import * as React from 'react';
import { MemberService } from '../../../remote-api/api/member-services';
import { EO2V2Autocomplete } from '../../../shared-components';
import { Autocomplete } from '@material-ui/lab';
import { ClientTypeService, PlanService } from '../../../remote-api/eo2v2-remote-api';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import { StatefulTargetBox as TargetBox } from './targetbox';

const memberservice = new MemberService();
const planservice = new PlanService();
const clienttypeervice = new ClientTypeService();

export default function CoinsuranceModal(props) {
  console.log(props);

  const handleClose = () => {
    props.closeCoinsuranceModal();
  };

  const isAddMoreDisabled = props.coinsurance.some(
    row =>
      !row.insuranceAddress?.trim() ||
      !row.branchCode?.trim() ||
      !row.sharePercentage?.toString().trim() ||
      !row.branchCode?.trim() ||
      !row.sharePercentage?.trim(),
  );

  return (
    <Dialog open={props.openCoinsurance} onClose={handleClose} fullWidth maxWidth="lg" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Co - Insurance</DialogTitle>
      <DialogContent>
        {props.coinsurance.map((row, idx) => (
          <Grid
            container
            spacing={1}
            alignItems="center"
            key={idx}
            style={{ marginBottom: 8, flexWrap: 'nowrap' }} // single line
          >
            <Grid item xs={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Insurer</InputLabel>
                <Select
                  value={row.insurer || ''}
                  onChange={e => props.updateFieldCoinsurance(idx, 'insurer', e.target.value)}>
                  <MenuItem value="Insurer 1">Insurer 1</MenuItem>
                  <MenuItem value="Insurer 2">Insurer 2</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Co-Insurance Type</InputLabel>
                <Select value={row.type || ''} onChange={e => props.updateFieldCoinsurance(idx, 'type', e.target.value)}>
                  <MenuItem value="Type 1">Type 1</MenuItem>
                  <MenuItem value="Type 2">Type 2</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={2}>
              <TextField
                fullWidth
                size="small"
                label="Insurer Address"
                multiline
                minRows={1}
                value={row.insuranceAddress}
                onChange={e => props.updateFieldCoinsurance(idx, 'insuranceAddress', e.target.value)}
                // disabled={idx !== 0}
              />
            </Grid>

            <Grid item xs={1.5}>
              <TextField
                fullWidth
                size="small"
                label="Branch Code"
                value={row.branchCode}
                onChange={e => props.updateFieldCoinsurance(idx, 'branchCode', e.target.value)}
              />
            </Grid>

            <Grid item xs={1.5}>
              <TextField
                fullWidth
                size="small"
                label="Share %"
                value={row.sharePercentage}
                onChange={e => props.updateFieldCoinsurance(idx, 'sharePercentage', e.target.value)}
              />
            </Grid>

            {/* Only show for first row */}
            {idx === 0 && (
              <>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Admin Charge"
                    value={row.adminCharge}
                    InputLabelProps={{ shrink: true }}
                    onChange={e => props.updateFieldCoinsurance(idx, 'adminCharge', e.target.value)}
                  />
                </Grid>

                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size="small"
                    label="UW Ref No"
                    value={row.uwRefNo}
                    InputLabelProps={{ shrink: true }}
                    onChange={e => props.updateFieldCoinsurance(idx, 'uwRefNo', e.target.value)}
                  />
                </Grid>
              </>
            )}

            {/* <Grid item>
              {props.coinsurance.length > 1 && (
                <Tooltip title="Remove">
                  <IconButton color="secondary" onClick={() => props.handleRemoveCoinsurance(idx)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Grid> */}
            <Grid item>
              {props.coinsurance.length > 1 && idx !== 0 && (
                <IconButton onClick={() => props.handleRemoveCoinsurance(idx)}>
                  <DeleteIcon color="error" />
                </IconButton>
              )}
            </Grid>
          </Grid>
        ))}

        <Grid container justifyContent="flex-end" style={{ marginTop: 8 }}>
          <Button variant="contained" color="primary" disabled={isAddMoreDisabled} onClick={props.handleAddCoinsurance}>
            <AddIcon /> Add More
          </Button>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button color="secondary">Submit</Button>
      </DialogActions>
    </Dialog>
  );
}
